class MenuShortcuts extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.menu-shortcuts__button');
    this.headerDrawer = document.querySelector('header-drawer');
  }

  connectedCallback() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleClick.bind(this));
    });

    this.observeDrawerMenuSelection();
    this.observeDrawerState();
  }

  handleClick(event) {
    const button = event.currentTarget;
    const menuTitle = button.dataset.menuTitle;
    const menuIndex = parseInt(button.dataset.menuIndex, 10);

    this.setActiveButton(button);

    if (!this.headerDrawer) {
      this.headerDrawer = document.querySelector('header-drawer');
    }

    if (!this.headerDrawer) return;

    const drawerDetails = this.headerDrawer.querySelector('details.menu-drawer-container');
    const drawerSummary = this.headerDrawer.querySelector('details > summary');

    if (drawerSummary && drawerDetails) {
      const isOpen = drawerDetails.open;

      if (!isOpen) {
        const menuItem = this.findDrawerMenuItem(menuTitle, menuIndex);
        if (menuItem) {
          this.headerDrawer.querySelectorAll('.menu-item--first-level').forEach(item => {
            item.classList.remove('selected');
          });
          menuItem.classList.add('selected');
        }

        this.clickDrawerMenuItem(menuTitle, menuIndex);

        setTimeout(() => {
          drawerSummary.click();  
        }, 150);
      } else {
        this.clickDrawerMenuItem(menuTitle, menuIndex);
      }
    }
  }

  setActiveButton(activeButton) {
    this.buttons.forEach(btn => btn.classList.remove('selected'));
    activeButton.classList.add('selected');
  }

  observeDrawerMenuSelection() {
    if (!this.headerDrawer) {
      this.headerDrawer = document.querySelector('header-drawer');
    }

    if (!this.headerDrawer) return;

    const drawerMenuItems = this.headerDrawer.querySelectorAll('.menu-drawer__first-level-details > summary.menu-item--first-level');

    drawerMenuItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        const itemText = item.textContent.trim().toLowerCase();

        for (const button of this.buttons) {
          const buttonTitle = button.dataset.menuTitle.toLowerCase();
          if (itemText.includes(buttonTitle) || buttonTitle.includes(itemText)) {
            this.setActiveButton(button);
            return;
          }
        }

        if (this.buttons[index]) {
          this.setActiveButton(this.buttons[index]);
        }
      });
    });
  }

  observeDrawerState() {
    if (!this.headerDrawer) {
      this.headerDrawer = document.querySelector('header-drawer');
    }

    if (!this.headerDrawer) return;

    const drawerDetails = this.headerDrawer.querySelector('details.menu-drawer-container');

    if (!drawerDetails) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          if (drawerDetails.hasAttribute('open')) {
            this.classList.add('fade-out');
          } else {
            this.classList.remove('fade-out');
          }
        }
      });
    });

    observer.observe(drawerDetails, { attributes: true });
  }

  findDrawerMenuItem(title, index) {
    const menuItems = this.headerDrawer.querySelectorAll('.menu-drawer__first-level-details > summary.menu-item--first-level');
    const normalizedTitle = title.toLowerCase().trim();

    for (const item of menuItems) {
      const itemText = item.textContent.trim().toLowerCase();
      if (itemText.includes(normalizedTitle) || normalizedTitle.includes(itemText)) {
        return item;
      }
    }

    return menuItems[index] || null;
  }

  clickDrawerMenuItem(title, index) {
    const menuItem = this.findDrawerMenuItem(title, index);
    if (menuItem) {
      menuItem.click();
    }
  }
}

if (!customElements.get('menu-shortcuts')) {
  customElements.define('menu-shortcuts', MenuShortcuts);
}
